module.exports = __webpack_public_path__ + "static/media/swatchbook.7cc9a757.svg";